import axios from "axios";
import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";
class ArticleServices {
  constructor(api) {
    this.api = api;
  }

  getAll(params = {}) {
    return this.api.get(ApiUrl + "article", {
      ...header("json"),
      params,
    });
  }

  getAllShuffled(params = {}) {
    return this.api.get(ApiUrl + "article/shuffled", {
      ...header("json"),
      params,
    });
  }

  getArticlesGroupedByCategory(params = {}) {
    return this.api.get(ApiUrl + "article/grouped/category", {
      ...header("json"),
      params,
    });
  }

  getOne(id) {
    return this.api.get(ApiUrl + `article/${id}`);
  }

  create(query = "", data) {
    return this.api.post(ApiUrl + "article" + query, data, header("image"));
  }

  update(query = "", id, data) {
    return this.api.put(
      ApiUrl + `article/${id}` + query,
      data,
      header("image"),
    );
  }

  updateArticleStatus(id, data) {
    return this.api.patch(ApiUrl + `article/${id}`, data);
  }

  updateArticleCounter(id, data) {
    return this.api.patch(ApiUrl + `article/counter/${id}`, data, {
      ...header("json"),
    });
  }

  getSuggestion(params = {}) {
    return this.api.get(
      ApiUrl + "article/search/suggestion/search-suggestions",
      {
        ...header("json"),
        params,
      },
    );
  }

  findOneArticleWithCategorie(id) {
    return this.api.get(ApiUrl + `article/categorie/${id}`);
  }

  getLatestArticleByUser(id) {
    return this.api.get(
      ApiUrl + `article/latest/user/pseudo/${id}`,
      header("json"),
    );
  }

  getPublicationStats(params = {}) {
    return this.api.get(ApiUrl + "article/stats/publications", {
      ...header("json"),
      params,
    });
  }

  getArticleContactEntries(id) {
    return this.api.get(
      ApiUrl + `article/${id}/contact-entries`,
      header("json"),
    );
  }

  qualifyContactEntry(id, canal, entryId, data) {
    return this.api.patch(
      ApiUrl + `article/${id}/qualify/${canal}/${entryId}`,
      { statut: data },
    );
  }
}

export default ArticleServices;
